import moment from 'moment';

import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import styles from "../../cards.module.scss"

function DateItem({ date, handleClickDate, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickDate}>

      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>
            {moment(date.date).format('LL')}
          </p>
          <div className="flex flex-col gap-1">
            <span className={styles.subtitle}>
              {date.schedule}</span>
            <span className={styles.subtitle}>
              {date.details}</span>
          </div>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('quatrebis.dateType', date.type).label,
              bgColor: 'bg-sky-950'
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DateItem;
